module.exports = "//img1.rrcimg.com/_next/static/src/assets/loading_TgPe0.png";